import { render, staticRenderFns } from "./UrlShortener.vue?vue&type=template&id=4a12e494&scoped=true&"
import script from "./UrlShortener.vue?vue&type=script&lang=js&"
export * from "./UrlShortener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12e494",
  null
  
)

export default component.exports